<template>
  <div v-if="brands.length" class="section-brands pt-5 pt-sm-10">
    <div class="d-flex justify-center flex-column align-center">
      <span
        class="
          font-italic font-weight-bold
          primary--text
          text-uppercase text-h4 text-sm-h3 text-center
        "
      >
        Marcas de Pneus Disponíveis
      </span>
      <div class="font-weight-medium text-sm-h5 text-h6 text-center">
        <span class="open-sans">Encontre a melhor opção para você!</span>
      </div>
    </div>
    <v-container
      v-if="!xs"
      class="
        brands-container
        justify-center justify-md-start justify-lg-start
        pb-16
        pt-6
      "
    >
      <div
        class="brands mt-12 d-flex align-center"
        v-for="({ img, link }, key) in brands"
        :key="key"
      >
        <a v-if="link" target="_blank" :href="link">
          <img :src="files + img" alt="Brands" height="" />
        </a>
        <img v-else :src="files + img" alt="Brands" height="" />
      </div>
    </v-container>
    <v-container v-else class="pt-10">
      <div class="relative">
        <VueSlickCarousel
          class="vue-slick-carousel px-7"
          v-bind="settings"
          ref="carousel"
        >
          <v-row
            v-for="(item, itemKey) in brandsMobile"
            :key="itemKey"
            class="d-flex"
          >
            <v-col
              class="brands-mobile pa-5 pa-sm-8"
              v-for="({ img, title, link }, i) in item"
              :key="i"
              cols="6"
            >
              <a v-if="link" :href="link" target="_blank">
                <img width="100%" :src="files + img" :alt="title" />
              </a>
              <img v-else width="100%" :src="files + img" :alt="title" />
            </v-col>
          </v-row>
        </VueSlickCarousel>
        <div class="d-flex justify-space-between vue-slick-carousel-nav">
          <v-btn class="transparent" icon text @click="showPrev">
            <v-icon color="primary" size="24"> fas fa-chevron-left </v-icon>
          </v-btn>
          <v-btn class="transparent" icon text @click="showNext">
            <v-icon color="primary" size="24"> fas fa-chevron-right </v-icon>
          </v-btn>
        </div>
      </div>
    </v-container>
  </div>
</template>

<script>
import VueSlickCarousel from "vue-slick-carousel";
import "vue-slick-carousel/dist/vue-slick-carousel.css";
import "vue-slick-carousel/dist/vue-slick-carousel-theme.css";

export default {
  data: () => ({
    settings: {
      swipe: true,
      dots: false,
      infinite: true,
      arrows: false,
      autoplay: true,
      slidesToScroll: 1,
      slidesToShow: 1,
      pauseOnHover: true,
    },
  }),
  computed: {
    xs() {
      return this.$vuetify.breakpoint.xsOnly;
    },
    brands() {
      return this.$rest("brands").list;
    },
    brandsMobile() {
      const newBrands = [];
      const brands = this.brands;

      for (let i = 0; i < brands.length; i += 4) {
        newBrands.push(brands.slice(i, i + 4));
      }
      return newBrands;
    },
  },
  methods: {
    showNext() {
      this.$refs.carousel.next();
    },
    showPrev() {
      this.$refs.carousel.prev();
    },
  },
  components: { VueSlickCarousel },
};
</script>

<style lang="scss">
.section-brands {
  .vue-slick-carousel-nav {
    position: absolute;
    pointer-events: none;
    left: -25px;
    right: -25px;
    top: 50%;
    transform: translateY(-50%);
    z-index: 2;
    button {
      pointer-events: all;
    }
    @media (max-width: 960px) {
      left: -15px;
      right: -15px;
    }
  }
}

.brands-mobile img {
  aspect-ratio: 62 / 140;
  height: 62px;
  object-fit: contain !important;
  filter: grayscale(1);
  opacity: 0.35;
  transition: all 0.15s;
  &:hover {
    opacity: 1;
    filter: none;
  }
}

.brands-container {
  display: flex;
  flex-wrap: wrap;
}
.brands {
  margin-left: 13.5px;
  margin-right: 13.5px;
  height: 62px;
  width: 140px;
}
.brands-container a {
  height: 62px;
  width: 140px;
}
.brands img,
.brands a img {
  width: 100%;
  height: 100%;
  object-fit: contain !important;
  filter: grayscale(1);
  opacity: 0.35;
  transition: all 0.15s;
}
.brands img:hover {
  filter: grayscale(0);
  opacity: 1;
}
</style>
